"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpFormFile = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const form_file_html_1 = __importDefault(require("./form-file.html"));
const form_input_base_1 = require("./form-input-base");
let ItpFormFile = class ItpFormFile extends (0, vue_property_decorator_1.Mixins)(form_input_base_1.FormInputBase) {
    accept;
    browseText;
    dropPlaceholder;
};
exports.ItpFormFile = ItpFormFile;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormFile.prototype, "accept", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormFile.prototype, "browseText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpFormFile.prototype, "dropPlaceholder", void 0);
exports.ItpFormFile = ItpFormFile = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: form_file_html_1.default,
        inject: {
            componentContext: 'componentContext',
            formContext: { default: null }
        }
    })
], ItpFormFile);
//# sourceMappingURL=form-file.js.map